export default "/images/vendor/flag-icon-css/flags/1x1/ar.svg?64f19246b47680747fcb8870cae80389";